/** Header subtitle from server `allCount` (template/owner breakdown is not on the list API). */
export const briefingsIndexSummaryDescription = (
  briefingCount: number,
): string => {
  if (briefingCount === 0) {
    return "No briefings yet";
  }
  return briefingCount === 1 ? "1 briefing" : `${briefingCount} briefings`;
};
